import { createFileRoute } from "@tanstack/react-router";
import { faqPageScript, i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { UnscrambleHub } from "@/tools/word-unscrambler/pages/UnscrambleHub";

const PATH = "/word-unscrambler";

export const Route = createFileRoute("/word-unscrambler/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.wu_hub_meta_title() },
      { name: "description", content: m.wu_hub_meta_description() },
      { property: "og:title", content: m.wu_hub_meta_title() },
      { property: "og:description", content: m.wu_hub_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.wu_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.wu_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
      faqPageScript([
        { q: m.wu_hub_faq1_q(), a: m.wu_hub_faq1_a() },
        { q: m.wu_hub_faq2_q(), a: m.wu_hub_faq2_a() },
        { q: m.wu_hub_faq3_q(), a: m.wu_hub_faq3_a() },
        { q: m.wu_hub_faq4_q(), a: m.wu_hub_faq4_a() },
      ]),
    ],
  }),
  component: UnscrambleHub,
});
